/*
 * @Description: 系统内部需要全局使用的vuex
 * @Author: ywl
 * @Date: 2021-03-30 09:28:52
 * @LastEditors: ywl
 * @LastEditTime: 2021-03-31 15:44:31
 */
export default {
  namespaced: true,
  state: {
    actionMenu: null,
    actionMenuQuestionnaire: null,

    listLayout: localStorage.getItem('LISTLAYOUT') || '2',
    activeName: localStorage.getItem('ACTIVENAME') || '',
    collectionList: null,
    checkDelete: false  // 删除问卷，投票后提示框
  },
  getters: {
    actionMenu: (state: any) => state.actionMenu,
    actionMenuQuestionnaire: (state: any) => state.actionMenuQuestionnaire,
    listLayout: (state: any) => state.listLayout,
    activeName: (state: any) => state.activeName,
    collectionList: (state: any) => state.collectionList,
    checkDelete: (state: any) => state.checkDelete,
  },
  mutations: {

    SET_ACTION_MENU(state: any, payload: any) {
      state.actionMenu = payload;
      // sessionStorage.setItem('actionMenu', payload)
    },
    SET_ACTION_MENUQUESTIONNAIRE(state: any, payload: any) {
      state.actionMenuQuestionnaire = payload;
      // sessionStorage.setItem('actionMenu', payload)
    },
    SET_ACTION_LISTLAYOUT(state: any, payload: any) {
      state.listLayout = payload;
      localStorage.setItem('LISTLAYOUT', payload);
    },
    SET_ACTIVENAME(state: any, payload: any) {
      state.activeName = payload;
      localStorage.setItem('ACTIVENAME', payload);
    },
    SET_COLLECTION_LIST(state: any, payload: any) {
      state.collectionList = payload;
      // sessionStorage.setItem('actionMenu', payload)
    },
    SET_CHECKDELETE(state: any, payload: any) {
      console.log(payload)
      state.checkDelete = payload;
      // sessionStorage.setItem('actionMenu', payload)
    },
  },
  actions: {
    actionMenuName({ commit }: any, payload: any) {
      commit('SET_ACTION_MENU', payload);
    },
    actionMenuNameQuestionnaire({ commit }: any, payload: any) {
      commit('SET_ACTION_MENUQUESTIONNAIRE', payload);
    },
    actionListLayout({ commit }: any, payload: any) {
      commit('SET_ACTION_LISTLAYOUT', payload);
    },
    actionActiveName({ commit }: any, payload: any) {
      commit('SET_ACTIVENAME', payload);
    },
    actionCollection({ commit }: any, payload: any) {
      commit('SET_COLLECTION_LIST', payload);
    },
    actionCheckDelete({ commit }: any, payload: any) {
      commit('SET_CHECKDELETE', payload);
    },
  },
};
